export type CountryCodeEntry = {
  iso: string
  code: string
  flag: string
  name: string
}

// Dial codes from ITU E.164 via annexare/Countries. Names from CLDR Spanish.
// NANP territories share +1. Priority LATAM/Spain sit first; the rest are A–Z.
export const COUNTRY_CODES: CountryCodeEntry[] = [
  { iso: "MX", code: "+52", flag: "🇲🇽", name: "México" },
  { iso: "US", code: "+1", flag: "🇺🇸", name: "Estados Unidos" },
  { iso: "CO", code: "+57", flag: "🇨🇴", name: "Colombia" },
  { iso: "AR", code: "+54", flag: "🇦🇷", name: "Argentina" },
  { iso: "CL", code: "+56", flag: "🇨🇱", name: "Chile" },
  { iso: "PE", code: "+51", flag: "🇵🇪", name: "Perú" },
  { iso: "ES", code: "+34", flag: "🇪🇸", name: "España" },
  { iso: "BR", code: "+55", flag: "🇧🇷", name: "Brasil" },
  { iso: "GT", code: "+502", flag: "🇬🇹", name: "Guatemala" },
  { iso: "HN", code: "+504", flag: "🇭🇳", name: "Honduras" },
  { iso: "SV", code: "+503", flag: "🇸🇻", name: "El Salvador" },
  { iso: "CR", code: "+506", flag: "🇨🇷", name: "Costa Rica" },
  { iso: "PA", code: "+507", flag: "🇵🇦", name: "Panamá" },
  { iso: "EC", code: "+593", flag: "🇪🇨", name: "Ecuador" },
  { iso: "VE", code: "+58", flag: "🇻🇪", name: "Venezuela" },
  { iso: "BO", code: "+591", flag: "🇧🇴", name: "Bolivia" },
  { iso: "UY", code: "+598", flag: "🇺🇾", name: "Uruguay" },
  { iso: "PY", code: "+595", flag: "🇵🇾", name: "Paraguay" },
  { iso: "DO", code: "+1", flag: "🇩🇴", name: "República Dominicana" },
  { iso: "CU", code: "+53", flag: "🇨🇺", name: "Cuba" },
  { iso: "AF", code: "+93", flag: "🇦🇫", name: "Afganistán" },
  { iso: "AL", code: "+355", flag: "🇦🇱", name: "Albania" },
  { iso: "DE", code: "+49", flag: "🇩🇪", name: "Alemania" },
  { iso: "AD", code: "+376", flag: "🇦🇩", name: "Andorra" },
  { iso: "AO", code: "+244", flag: "🇦🇴", name: "Angola" },
  { iso: "AI", code: "+1", flag: "🇦🇮", name: "Anguila" },
  { iso: "AQ", code: "+672", flag: "🇦🇶", name: "Antártida" },
  { iso: "AG", code: "+1", flag: "🇦🇬", name: "Antigua y Barbuda" },
  { iso: "SA", code: "+966", flag: "🇸🇦", name: "Arabia Saudí" },
  { iso: "DZ", code: "+213", flag: "🇩🇿", name: "Argelia" },
  { iso: "AM", code: "+374", flag: "🇦🇲", name: "Armenia" },
  { iso: "AW", code: "+297", flag: "🇦🇼", name: "Aruba" },
  { iso: "AU", code: "+61", flag: "🇦🇺", name: "Australia" },
  { iso: "AT", code: "+43", flag: "🇦🇹", name: "Austria" },
  { iso: "AZ", code: "+994", flag: "🇦🇿", name: "Azerbaiyán" },
  { iso: "BS", code: "+1", flag: "🇧🇸", name: "Bahamas" },
  { iso: "BD", code: "+880", flag: "🇧🇩", name: "Bangladés" },
  { iso: "BB", code: "+1", flag: "🇧🇧", name: "Barbados" },
  { iso: "BH", code: "+973", flag: "🇧🇭", name: "Baréin" },
  { iso: "BE", code: "+32", flag: "🇧🇪", name: "Bélgica" },
  { iso: "BZ", code: "+501", flag: "🇧🇿", name: "Belice" },
  { iso: "BJ", code: "+229", flag: "🇧🇯", name: "Benín" },
  { iso: "BM", code: "+1", flag: "🇧🇲", name: "Bermudas" },
  { iso: "BY", code: "+375", flag: "🇧🇾", name: "Bielorrusia" },
  { iso: "BA", code: "+387", flag: "🇧🇦", name: "Bosnia y Herzegovina" },
  { iso: "BW", code: "+267", flag: "🇧🇼", name: "Botsuana" },
  { iso: "BN", code: "+673", flag: "🇧🇳", name: "Brunéi" },
  { iso: "BG", code: "+359", flag: "🇧🇬", name: "Bulgaria" },
  { iso: "BF", code: "+226", flag: "🇧🇫", name: "Burkina Faso" },
  { iso: "BI", code: "+257", flag: "🇧🇮", name: "Burundi" },
  { iso: "BT", code: "+975", flag: "🇧🇹", name: "Bután" },
  { iso: "CV", code: "+238", flag: "🇨🇻", name: "Cabo Verde" },
  { iso: "KH", code: "+855", flag: "🇰🇭", name: "Camboya" },
  { iso: "CM", code: "+237", flag: "🇨🇲", name: "Camerún" },
  { iso: "CA", code: "+1", flag: "🇨🇦", name: "Canadá" },
  { iso: "BQ", code: "+5997", flag: "🇧🇶", name: "Caribe neerlandés" },
  { iso: "QA", code: "+974", flag: "🇶🇦", name: "Catar" },
  { iso: "TD", code: "+235", flag: "🇹🇩", name: "Chad" },
  { iso: "CZ", code: "+420", flag: "🇨🇿", name: "Chequia" },
  { iso: "CN", code: "+86", flag: "🇨🇳", name: "China" },
  { iso: "CY", code: "+357", flag: "🇨🇾", name: "Chipre" },
  { iso: "VA", code: "+379", flag: "🇻🇦", name: "Ciudad del Vaticano" },
  { iso: "KM", code: "+269", flag: "🇰🇲", name: "Comoras" },
  { iso: "CG", code: "+242", flag: "🇨🇬", name: "Congo" },
  { iso: "KP", code: "+850", flag: "🇰🇵", name: "Corea del Norte" },
  { iso: "KR", code: "+82", flag: "🇰🇷", name: "Corea del Sur" },
  { iso: "CI", code: "+225", flag: "🇨🇮", name: "Côte d’Ivoire" },
  { iso: "HR", code: "+385", flag: "🇭🇷", name: "Croacia" },
  { iso: "CW", code: "+5999", flag: "🇨🇼", name: "Curazao" },
  { iso: "DK", code: "+45", flag: "🇩🇰", name: "Dinamarca" },
  { iso: "DM", code: "+1", flag: "🇩🇲", name: "Dominica" },
  { iso: "EG", code: "+20", flag: "🇪🇬", name: "Egipto" },
  { iso: "AE", code: "+971", flag: "🇦🇪", name: "Emiratos Árabes Unidos" },
  { iso: "ER", code: "+291", flag: "🇪🇷", name: "Eritrea" },
  { iso: "SK", code: "+421", flag: "🇸🇰", name: "Eslovaquia" },
  { iso: "SI", code: "+386", flag: "🇸🇮", name: "Eslovenia" },
  { iso: "EE", code: "+372", flag: "🇪🇪", name: "Estonia" },
  { iso: "SZ", code: "+268", flag: "🇸🇿", name: "Esuatini" },
  { iso: "ET", code: "+251", flag: "🇪🇹", name: "Etiopía" },
  { iso: "PH", code: "+63", flag: "🇵🇭", name: "Filipinas" },
  { iso: "FI", code: "+358", flag: "🇫🇮", name: "Finlandia" },
  { iso: "FJ", code: "+679", flag: "🇫🇯", name: "Fiyi" },
  { iso: "FR", code: "+33", flag: "🇫🇷", name: "Francia" },
  { iso: "GA", code: "+241", flag: "🇬🇦", name: "Gabón" },
  { iso: "GM", code: "+220", flag: "🇬🇲", name: "Gambia" },
  { iso: "GE", code: "+995", flag: "🇬🇪", name: "Georgia" },
  { iso: "GH", code: "+233", flag: "🇬🇭", name: "Ghana" },
  { iso: "GI", code: "+350", flag: "🇬🇮", name: "Gibraltar" },
  { iso: "GD", code: "+1", flag: "🇬🇩", name: "Granada" },
  { iso: "GR", code: "+30", flag: "🇬🇷", name: "Grecia" },
  { iso: "GL", code: "+299", flag: "🇬🇱", name: "Groenlandia" },
  { iso: "GP", code: "+590", flag: "🇬🇵", name: "Guadalupe" },
  { iso: "GU", code: "+1", flag: "🇬🇺", name: "Guam" },
  { iso: "GF", code: "+594", flag: "🇬🇫", name: "Guayana Francesa" },
  { iso: "GG", code: "+44", flag: "🇬🇬", name: "Guernesey" },
  { iso: "GN", code: "+224", flag: "🇬🇳", name: "Guinea" },
  { iso: "GQ", code: "+240", flag: "🇬🇶", name: "Guinea Ecuatorial" },
  { iso: "GW", code: "+245", flag: "🇬🇼", name: "Guinea-Bisáu" },
  { iso: "GY", code: "+592", flag: "🇬🇾", name: "Guyana" },
  { iso: "HT", code: "+509", flag: "🇭🇹", name: "Haití" },
  { iso: "HU", code: "+36", flag: "🇭🇺", name: "Hungría" },
  { iso: "IN", code: "+91", flag: "🇮🇳", name: "India" },
  { iso: "ID", code: "+62", flag: "🇮🇩", name: "Indonesia" },
  { iso: "IQ", code: "+964", flag: "🇮🇶", name: "Irak" },
  { iso: "IR", code: "+98", flag: "🇮🇷", name: "Irán" },
  { iso: "IE", code: "+353", flag: "🇮🇪", name: "Irlanda" },
  { iso: "BV", code: "+47", flag: "🇧🇻", name: "Isla Bouvet" },
  { iso: "AC", code: "+247", flag: "🇦🇨", name: "Isla de la Ascensión" },
  { iso: "IM", code: "+44", flag: "🇮🇲", name: "Isla de Man" },
  { iso: "CX", code: "+61", flag: "🇨🇽", name: "Isla de Navidad" },
  { iso: "NF", code: "+672", flag: "🇳🇫", name: "Isla Norfolk" },
  { iso: "IS", code: "+354", flag: "🇮🇸", name: "Islandia" },
  { iso: "AX", code: "+358", flag: "🇦🇽", name: "Islas Aland" },
  { iso: "KY", code: "+1", flag: "🇰🇾", name: "Islas Caimán" },
  { iso: "CC", code: "+61", flag: "🇨🇨", name: "Islas Cocos" },
  { iso: "CK", code: "+682", flag: "🇨🇰", name: "Islas Cook" },
  { iso: "FO", code: "+298", flag: "🇫🇴", name: "Islas Feroe" },
  { iso: "GS", code: "+500", flag: "🇬🇸", name: "Islas Georgia del Sur y Sandwich del Sur" },
  { iso: "HM", code: "+61", flag: "🇭🇲", name: "Islas Heard y McDonald" },
  { iso: "FK", code: "+500", flag: "🇫🇰", name: "Islas Malvinas" },
  { iso: "MP", code: "+1", flag: "🇲🇵", name: "Islas Marianas del Norte" },
  { iso: "MH", code: "+692", flag: "🇲🇭", name: "Islas Marshall" },
  { iso: "UM", code: "+1", flag: "🇺🇲", name: "Islas menores alejadas de EE. UU." },
  { iso: "PN", code: "+64", flag: "🇵🇳", name: "Islas Pitcairn" },
  { iso: "SB", code: "+677", flag: "🇸🇧", name: "Islas Salomón" },
  { iso: "TC", code: "+1", flag: "🇹🇨", name: "Islas Turcas y Caicos" },
  { iso: "VG", code: "+1", flag: "🇻🇬", name: "Islas Vírgenes Británicas" },
  { iso: "VI", code: "+1", flag: "🇻🇮", name: "Islas Vírgenes de EE. UU." },
  { iso: "IL", code: "+972", flag: "🇮🇱", name: "Israel" },
  { iso: "IT", code: "+39", flag: "🇮🇹", name: "Italia" },
  { iso: "JM", code: "+1", flag: "🇯🇲", name: "Jamaica" },
  { iso: "JP", code: "+81", flag: "🇯🇵", name: "Japón" },
  { iso: "JE", code: "+44", flag: "🇯🇪", name: "Jersey" },
  { iso: "JO", code: "+962", flag: "🇯🇴", name: "Jordania" },
  { iso: "KZ", code: "+7", flag: "🇰🇿", name: "Kazajistán" },
  { iso: "KE", code: "+254", flag: "🇰🇪", name: "Kenia" },
  { iso: "KG", code: "+996", flag: "🇰🇬", name: "Kirguistán" },
  { iso: "KI", code: "+686", flag: "🇰🇮", name: "Kiribati" },
  { iso: "XK", code: "+377", flag: "🇽🇰", name: "Kosovo" },
  { iso: "KW", code: "+965", flag: "🇰🇼", name: "Kuwait" },
  { iso: "LA", code: "+856", flag: "🇱🇦", name: "Laos" },
  { iso: "LS", code: "+266", flag: "🇱🇸", name: "Lesoto" },
  { iso: "LV", code: "+371", flag: "🇱🇻", name: "Letonia" },
  { iso: "LB", code: "+961", flag: "🇱🇧", name: "Líbano" },
  { iso: "LR", code: "+231", flag: "🇱🇷", name: "Liberia" },
  { iso: "LY", code: "+218", flag: "🇱🇾", name: "Libia" },
  { iso: "LI", code: "+423", flag: "🇱🇮", name: "Liechtenstein" },
  { iso: "LT", code: "+370", flag: "🇱🇹", name: "Lituania" },
  { iso: "LU", code: "+352", flag: "🇱🇺", name: "Luxemburgo" },
  { iso: "MK", code: "+389", flag: "🇲🇰", name: "Macedonia del Norte" },
  { iso: "MG", code: "+261", flag: "🇲🇬", name: "Madagascar" },
  { iso: "MY", code: "+60", flag: "🇲🇾", name: "Malasia" },
  { iso: "MW", code: "+265", flag: "🇲🇼", name: "Malaui" },
  { iso: "MV", code: "+960", flag: "🇲🇻", name: "Maldivas" },
  { iso: "ML", code: "+223", flag: "🇲🇱", name: "Mali" },
  { iso: "MT", code: "+356", flag: "🇲🇹", name: "Malta" },
  { iso: "MA", code: "+212", flag: "🇲🇦", name: "Marruecos" },
  { iso: "MQ", code: "+596", flag: "🇲🇶", name: "Martinica" },
  { iso: "MU", code: "+230", flag: "🇲🇺", name: "Mauricio" },
  { iso: "MR", code: "+222", flag: "🇲🇷", name: "Mauritania" },
  { iso: "YT", code: "+262", flag: "🇾🇹", name: "Mayotte" },
  { iso: "FM", code: "+691", flag: "🇫🇲", name: "Micronesia" },
  { iso: "MD", code: "+373", flag: "🇲🇩", name: "Moldavia" },
  { iso: "MC", code: "+377", flag: "🇲🇨", name: "Mónaco" },
  { iso: "MN", code: "+976", flag: "🇲🇳", name: "Mongolia" },
  { iso: "ME", code: "+382", flag: "🇲🇪", name: "Montenegro" },
  { iso: "MS", code: "+1", flag: "🇲🇸", name: "Montserrat" },
  { iso: "MZ", code: "+258", flag: "🇲🇿", name: "Mozambique" },
  { iso: "MM", code: "+95", flag: "🇲🇲", name: "Myanmar (Birmania)" },
  { iso: "NA", code: "+264", flag: "🇳🇦", name: "Namibia" },
  { iso: "NR", code: "+674", flag: "🇳🇷", name: "Nauru" },
  { iso: "NP", code: "+977", flag: "🇳🇵", name: "Nepal" },
  { iso: "NI", code: "+505", flag: "🇳🇮", name: "Nicaragua" },
  { iso: "NE", code: "+227", flag: "🇳🇪", name: "Níger" },
  { iso: "NG", code: "+234", flag: "🇳🇬", name: "Nigeria" },
  { iso: "NU", code: "+683", flag: "🇳🇺", name: "Niue" },
  { iso: "NO", code: "+47", flag: "🇳🇴", name: "Noruega" },
  { iso: "NC", code: "+687", flag: "🇳🇨", name: "Nueva Caledonia" },
  { iso: "NZ", code: "+64", flag: "🇳🇿", name: "Nueva Zelanda" },
  { iso: "OM", code: "+968", flag: "🇴🇲", name: "Omán" },
  { iso: "NL", code: "+31", flag: "🇳🇱", name: "Países Bajos" },
  { iso: "PK", code: "+92", flag: "🇵🇰", name: "Pakistán" },
  { iso: "PW", code: "+680", flag: "🇵🇼", name: "Palaos" },
  { iso: "PG", code: "+675", flag: "🇵🇬", name: "Papúa Nueva Guinea" },
  { iso: "PF", code: "+689", flag: "🇵🇫", name: "Polinesia Francesa" },
  { iso: "PL", code: "+48", flag: "🇵🇱", name: "Polonia" },
  { iso: "PT", code: "+351", flag: "🇵🇹", name: "Portugal" },
  { iso: "PR", code: "+1", flag: "🇵🇷", name: "Puerto Rico" },
  { iso: "HK", code: "+852", flag: "🇭🇰", name: "RAE de Hong Kong (China)" },
  { iso: "MO", code: "+853", flag: "🇲🇴", name: "RAE de Macao (China)" },
  { iso: "GB", code: "+44", flag: "🇬🇧", name: "Reino Unido" },
  { iso: "CF", code: "+236", flag: "🇨🇫", name: "República Centroafricana" },
  { iso: "CD", code: "+243", flag: "🇨🇩", name: "República Democrática del Congo" },
  { iso: "RE", code: "+262", flag: "🇷🇪", name: "Reunión" },
  { iso: "RW", code: "+250", flag: "🇷🇼", name: "Ruanda" },
  { iso: "RO", code: "+40", flag: "🇷🇴", name: "Rumanía" },
  { iso: "RU", code: "+7", flag: "🇷🇺", name: "Rusia" },
  { iso: "EH", code: "+212", flag: "🇪🇭", name: "Sáhara Occidental" },
  { iso: "WS", code: "+685", flag: "🇼🇸", name: "Samoa" },
  { iso: "AS", code: "+1", flag: "🇦🇸", name: "Samoa Americana" },
  { iso: "BL", code: "+590", flag: "🇧🇱", name: "San Bartolomé" },
  { iso: "KN", code: "+1", flag: "🇰🇳", name: "San Cristóbal y Nieves" },
  { iso: "SM", code: "+378", flag: "🇸🇲", name: "San Marino" },
  { iso: "MF", code: "+590", flag: "🇲🇫", name: "San Martín" },
  { iso: "PM", code: "+508", flag: "🇵🇲", name: "San Pedro y Miquelón" },
  { iso: "VC", code: "+1", flag: "🇻🇨", name: "San Vicente y las Granadinas" },
  { iso: "SH", code: "+290", flag: "🇸🇭", name: "Santa Elena" },
  { iso: "LC", code: "+1", flag: "🇱🇨", name: "Santa Lucía" },
  { iso: "ST", code: "+239", flag: "🇸🇹", name: "Santo Tomé y Príncipe" },
  { iso: "SN", code: "+221", flag: "🇸🇳", name: "Senegal" },
  { iso: "RS", code: "+381", flag: "🇷🇸", name: "Serbia" },
  { iso: "SC", code: "+248", flag: "🇸🇨", name: "Seychelles" },
  { iso: "SL", code: "+232", flag: "🇸🇱", name: "Sierra Leona" },
  { iso: "SG", code: "+65", flag: "🇸🇬", name: "Singapur" },
  { iso: "SX", code: "+1", flag: "🇸🇽", name: "Sint Maarten" },
  { iso: "SY", code: "+963", flag: "🇸🇾", name: "Siria" },
  { iso: "SO", code: "+252", flag: "🇸🇴", name: "Somalia" },
  { iso: "LK", code: "+94", flag: "🇱🇰", name: "Sri Lanka" },
  { iso: "ZA", code: "+27", flag: "🇿🇦", name: "Sudáfrica" },
  { iso: "SD", code: "+249", flag: "🇸🇩", name: "Sudán" },
  { iso: "SS", code: "+211", flag: "🇸🇸", name: "Sudán del Sur" },
  { iso: "SE", code: "+46", flag: "🇸🇪", name: "Suecia" },
  { iso: "CH", code: "+41", flag: "🇨🇭", name: "Suiza" },
  { iso: "SR", code: "+597", flag: "🇸🇷", name: "Surinam" },
  { iso: "SJ", code: "+4779", flag: "🇸🇯", name: "Svalbard y Jan Mayen" },
  { iso: "TH", code: "+66", flag: "🇹🇭", name: "Tailandia" },
  { iso: "TW", code: "+886", flag: "🇹🇼", name: "Taiwán" },
  { iso: "TZ", code: "+255", flag: "🇹🇿", name: "Tanzania" },
  { iso: "TJ", code: "+992", flag: "🇹🇯", name: "Tayikistán" },
  { iso: "IO", code: "+246", flag: "🇮🇴", name: "Territorio Británico del Océano Índico" },
  { iso: "TF", code: "+262", flag: "🇹🇫", name: "Territorios Australes Franceses" },
  { iso: "PS", code: "+970", flag: "🇵🇸", name: "Territorios Palestinos" },
  { iso: "TL", code: "+670", flag: "🇹🇱", name: "Timor-Leste" },
  { iso: "TG", code: "+228", flag: "🇹🇬", name: "Togo" },
  { iso: "TK", code: "+690", flag: "🇹🇰", name: "Tokelau" },
  { iso: "TO", code: "+676", flag: "🇹🇴", name: "Tonga" },
  { iso: "TT", code: "+1", flag: "🇹🇹", name: "Trinidad y Tobago" },
  { iso: "TA", code: "+290", flag: "🇹🇦", name: "Tristán de Acuña" },
  { iso: "TN", code: "+216", flag: "🇹🇳", name: "Túnez" },
  { iso: "TM", code: "+993", flag: "🇹🇲", name: "Turkmenistán" },
  { iso: "TR", code: "+90", flag: "🇹🇷", name: "Turquía" },
  { iso: "TV", code: "+688", flag: "🇹🇻", name: "Tuvalu" },
  { iso: "UA", code: "+380", flag: "🇺🇦", name: "Ucrania" },
  { iso: "UG", code: "+256", flag: "🇺🇬", name: "Uganda" },
  { iso: "UZ", code: "+998", flag: "🇺🇿", name: "Uzbekistán" },
  { iso: "VU", code: "+678", flag: "🇻🇺", name: "Vanuatu" },
  { iso: "VN", code: "+84", flag: "🇻🇳", name: "Vietnam" },
  { iso: "WF", code: "+681", flag: "🇼🇫", name: "Wallis y Futuna" },
  { iso: "YE", code: "+967", flag: "🇾🇪", name: "Yemen" },
  { iso: "DJ", code: "+253", flag: "🇩🇯", name: "Yibuti" },
  { iso: "ZM", code: "+260", flag: "🇿🇲", name: "Zambia" },
  { iso: "ZW", code: "+263", flag: "🇿🇼", name: "Zimbabue" },
]
